<template>
  <div class="my-account__wrapper relative">
    <div class="my-account__sidebar">
      <span class="my-account__sidebar__title">
        {{ $t("settings.profile.title") }}
      </span>
      <ul class="my-account__sidebar__list">
        <li>
          <router-link
            :to="{ path: '/my-profile' }"
            class="my-account__sidebar__list__item"
            :class="{
              active:
                activeLink === '/my-profile' || activeLink === '/my-profile',
            }"
          >
            <span class="text">{{ $t("navigation.profile.info") }}</span>
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.75 11.4905L9.25 7.99048L5.75 4.49048"
                stroke="#848FAC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ path: '/change-password' }"
            class="my-account__sidebar__list__item"
            :class="{
              active:
                activeLink === '/change-password' ||
                activeLink === '/change-password',
            }"
          >
            <span class="text">{{ $t("navigation.profile.pass") }}</span>
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.75 11.4905L9.25 7.99048L5.75 4.49048"
                stroke="#848FAC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ path: '/preferences' }"
            class="my-account__sidebar__list__item"
            :class="{
              active:
                activeLink === '/preferences' || activeLink === '/preferences',
            }"
          >
            <span class="text">{{ $t("navigation.profile.preference") }}</span>
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.75 11.4905L9.25 7.99048L5.75 4.49048"
                stroke="#848FAC"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    activeLink() {
      return this.$route.path;
    },
  },
};
</script>
<style>
@import "index.module.css";
</style>
